<template>
    <div
        class="md-hero template6 column"
        :class="[
            `banner-with-${searchStyle}`,
            isVideoPlay &&
                videoOption &&
                (videoOption.autoplay || videoOption.playInline)
                ? 'video-in-play'
                : ''
        ]"
        :style="{ paddingBottom: marginBottom }"
    >
        <div
            class="hero-border"
            :style="{
                transform: `translate(-50% , calc(-50% - ${boxTranslate}))`
            }"
        >
            <div class="border-box"></div>
        </div>
        <banner
            ref="banner"
            :type="type"
            :mobileType="mobileType"
            :useMobileSettings="useMobileSettings"
            :sizeOption="sizeOption"
            :pictureOption="pictureOption"
            :mobilePicture="mobilePicture"
            :pictureListOption="pictureListOption"
            :mobilePictureListOption="mobilePictureListOption"
            :maskOption="maskOption"
            :videoOption="videoOption"
            :mobileVideoOption="mobileVideoOption"
            @updateVideoPlay="updateVideoPlay"
        >
            <media-content
                :class="`media-content-${searchStyle}`"
                :type="contentType"
                :title="title"
                :imgAlign="imgAlign"
                :subTitle="subTitle"
                :titlePic="titlePic"
                :showShadow="showShadow"
                :layout="searchBarLayout"
                class="row2column"
            >
                <template #info>
                    <div
                        v-if="useType === 'video'"
                        class="play-video"
                        @click.stop="doVideoPlay"
                    ></div>
                </template>
                <div v-if="useType === 'video'" class="video-loading"></div>
                <div class="media-content-box" @click="avoidEmitMedia">
                    <component
                        :is="searchBar"
                        v-if="searchStyle === 'search-bar'"
                        :needSearchCondition="true"
                        :configFilter="configFilter"
                        :placeholder="searchbarPlaceholder"
                        :submitText="computedSearchBtnText"
                        :class="searchBarLayout"
                        class="row2column"
                    />
                    <search-group
                        v-if="searchStyle === 'search-group'"
                        :needSearchCondition="false"
                        :searchGroupTabs="searchGroupTabs"
                        :searchGroupConfig="searchGroupConfig"
                        :nameType="nameType"
                        :nameRequired="nameRequired"
                        :phoneRequired="phoneRequired"
                        :class="searchBarLayout"
                        class="row2column"
                    />
                    <banner-button
                        v-if="searchStyle === 'search-btn'"
                        :buttons="buttons"
                        :class="searchBarLayout"
                        class="row2column"
                    />
                </div>
            </media-content>
        </banner>
    </div>
</template>

<script>
import common from '../index.js';
import mixinsSearchBar from './mixins-search-bar';
import MediaContent from '../../../components/media-content.vue';
import BannerButton from '../../../components/banner-button.vue';
import SearchGroup from './search-group.vue';
export default {
    mixins: [common, mixinsSearchBar],
    data: function() {
        return {
            isVideoPlay: false
        };
    },
    methods: {
        updateVideoPlay(flag) {
            this.isVideoPlay = flag;
        }
    },
    computed: {
        boxTranslate() {
            return (
                (this.isMobileSize
                    ? this.mobileBtmSpacing / 2
                    : this.btmSpacing / 2) + 'px'
            );
        }
    },
    components: {
        MediaContent,
        BannerButton,
        SearchGroup
    }
};
</script>

<style lang="scss">
@import '../../../theme/mixin.scss';
@import '../../../theme/media.scss';

@mixin title-text {
    .title-text {
        .media-title {
            font-size: 30px;
            line-height: 40px;
        }

        .media-subtitle {
            font-size: 14px;
            line-height: 24px;
        }
    }
}

@mixin search-by-section {
    .search-by-section {
        border-bottom: 1px solid var(--color-border);

        .search-category {
            box-shadow: none;

            .keyword-submit {
                @include color-button-hover();
                min-width: 0;
                @include color-button();
                .search-text {
                    display: none;
                }
            }
        }
    }
}

.md-hero.template6 {
    background-color: #191919;
    .hero-border {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translateX(-50%);
        max-width: 1080px;
        width: 80%;
        height: 50%;
        z-index: 10;
        .border-box {
            margin-left: -50px;
            width: 23%;
            height: 100%;
            box-sizing: border-box;
            opacity: 0.5;
            border: 6px solid var(--mg-button-background);
        }
        @include media-800 {
            height: 40%;
            width: calc(100% - 90px);
            max-height: 200px;
            .border-box {
                margin: 0;
                box-sizing: border-box;
                width: 100px;
            }
        }
    }
    .hero-border {
        pointer-events: none;
    }
    .banner {
        .media-content {
            pointer-events: none;
            .media-content-box {
                pointer-events: none;
                .banner-button {
                    .btn-item {
                        pointer-events: all;
                    }
                }
                .search-bar {
                    pointer-events: all;
                }
                .search-group {
                    pointer-events: all;
                }
            }
        }
    }

    &.banner-with-search-bar {
        @mixin banner-with-search-bar_column {
            margin-bottom: 160px;
            &.video-in-play {
                margin-bottom: 237px;
                .search-bar {
                    top: 100%;
                }
            }
            .media-content {
                position: static;
            }
            .search-bar {
                width: 1080px;
                max-width: calc(100% - 30px);
                position: absolute;
                top: calc(100% - 90px);
                transition: top 0.3s ease;
                left: 50%;
                transform: translateX(-50%);
                z-index: var(--level-sublow);
            }
        }
        @include media-min-800 {
            &.column {
                @include banner-with-search-bar_column;
            }
        }
        @media (min-width: 800px) and (max-width: 1080px) {
            &.row2column {
                @include banner-with-search-bar_column;
            }
        }
        @include media-800 {
            margin-bottom: 58px;
            .media-content {
                position: static;
                @include title-text;
                .search-bar {
                    position: absolute;
                    width: calc(100% - 30px);
                    padding: 28px 15px;
                    top: calc(100% - 58px);
                    left: 15px;
                    @include search-by-section;
                    display: flex;
                    .condition-search {
                        display: none;
                    }
                    .search-by-section {
                        border: none;
                        .search-list-panel {
                            top: 40px;
                        }
                        .search-category {
                            position: relative;
                            .keyword-submit {
                                display: none;
                            }
                        }
                    }
                    > .keyword-submit {
                        display: block;
                        margin: 0;
                        font-size: 16px;
                        line-height: 60px;
                    }
                }
            }
        }
    }

    &.banner-with-search-group {
        @mixin banner-with-search-group_column {
            margin-bottom: 80px;
            &.video-in-play {
                .search-group {
                    top: 100%;
                }
            }
            .media-content {
                position: static;
            }
            .search-group {
                max-width: 1080px;
                width: 80%;
                position: absolute;
                top: calc(100% - 90px);
                transition: top 0.3s ease;
                left: 50%;
                transform: translateX(-50%);
            }
        }
        @include media-min-800 {
            &.column {
                @include banner-with-search-group_column;
            }
        }
        @media (min-width: 800px) and (max-width: 1080px) {
            &.row2column {
                @include banner-with-search-group_column;
            }
        }
        @include media-800 {
            margin-bottom: 56px;
            .media-content {
                position: static;

                @include title-text;
                @include search-by-section;

                .search-group {
                    position: absolute;
                    top: calc(100% - 110px);
                    left: 0px;
                }
            }
        }
        .media-content.column .media-info:before {
            height: calc(100% + 60px);
        }
        @include media-1080 {
            .media-content.row2column .media-info:before {
                height: calc(100% + 60px);
            }
        }
    }

    &.banner-with-search-btn {
        .banner-button {
            width: 100%;
            flex-direction: row;
            justify-content: left;
            &.count-4 {
                max-width: 900px;
            }
            &.column {
                margin-top: 0;
            }
            @include media-1080 {
                &.row2column {
                    margin-top: 0;
                }
            }
            .btn-item {
                min-width: 140px;
                padding: 0 15px;
                margin: 30px 10px 0;
                font-size: 16px;
                font-family: var(--font-bold);
                height: 56px;
                line-height: 52px;
                border-width: 2px;
                border-color: #fff;
                background-color: #fff;
                color: var(--mg-button-background);
                &:hover {
                    background-color: #fdf7ef;
                    border-color: #fdf7ef;
                }
                &:first-child {
                    background-color: var(--mg-button-background);
                    border-color: var(--mg-button-background);
                    color: #fff;
                    margin-left: 0;
                    @include color-button-hover();
                }
                @include media-1080 {
                    padding: 0 10px;
                    height: 32px;
                    line-height: 28px;
                    text-shadow: none;
                }
            }
            @include media-800 {
                display: inline-block;
                width: auto;
                max-width: 100%;
                .btn-item {
                    margin: 15px 0 0;
                    padding: 0 10px;
                    border-radius: 2px;
                }
            }
        }
        .media-content.column .media-info:before {
            content: none;
        }
        @include media-1080 {
            .media-content.row2column .media-info:before {
                content: none;
            }
        }
        .media-content-box {
            text-align: center;
        }
    }

    .media-content {
        width: 80%;
        max-width: 1080px;
        z-index: calc(var(--level-sublow) + 1);
        @include media-800 {
            width: calc(100% - 90px);
            padding-left: 20px;
        }
        @mixin media-content_column {
            max-width: 1080px;
            .media-info {
                position: relative;
            }
        }
        &.column {
            @include media-content_column;
        }
        @include media-1080 {
            &.row2column {
                @include media-content_column;
            }
        }
        .media-info {
            width: 100%;
            max-width: 100%;
            pointer-events: auto;
        }
        .title-text {
            padding-top: 0;
            padding-bottom: 10px;
            .media-title {
                font-size: 70px;
                line-height: 1.35;
                word-break: break-word;
                text-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
                @include media-800 {
                    font-size: 30px;
                }
            }
            .media-subtitle {
                font-size: 24px;
                margin-top: 15px;
                text-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
                overflow: hidden;
                font-family: var(--font-normal);
                @include media-800 {
                    font-size: 14px;
                    line-height: 1.7;
                }
            }
            .media-shadow {
                background: hsla(0, 0%, 100%, 0.2);
                top: 32px;
                width: 840px;
                height: calc(100% + 21px);
                max-width: 110%;
            }
        }
        &.media-content-search-btn,
        &.media-content-search-group {
            .title-text .media-shadow {
                display: none;
            }
        }
        &.media-content-search-btn {
            @include media-800 {
                .media-content-box {
                    width: calc(100% + 20px);
                    .banner-button {
                        width: 100%;
                        justify-content: space-between;
                        display: flex;
                        flex-wrap: wrap;
                        position: absolute;
                        left: 0;
                        top: calc(100% + 90px);
                        .btn-item {
                            height: 40px;
                            line-height: 36px;
                            min-width: unset;
                            width: calc(50% - 8px);
                            margin-top: 0;
                            border-radius: 0;
                        }
                        .btn-item:nth-child(n + 3) {
                            margin-top: 10px;
                        }
                    }
                }
            }
        }

        @include media-600 {
            .title-text {
                padding: 0;
                // .media-title {
                //     font-size: 24px;
                //     line-height: 26px;
                // }
                .media-subtitle {
                    width: 254px;
                    margin: 0;
                    // font-size: 14px;
                }
                .media-shadow {
                    width: 300px;
                    top: 16px;
                }
            }
            .banner-button {
                margin-top: 18px;
            }
        }
    }
    .banner-video + .media-content {
        .title-text .media-shadow {
            display: none;
        }
        @include media-min-1080 {
            &.row {
                .play-video {
                    margin: 10px auto;
                }
            }
        }
        .play-video {
            margin: 10px auto 10px;
            width: 84px;
            height: 84px;
            background: url(//static.chimeroi.com/site3/images/play.png)
                no-repeat;
            background-size: cover;
            cursor: pointer;
            position: relative;
            pointer-events: all;
            &:before {
                content: '';
                position: absolute;
                left: -7px;
                top: -7px;
                width: calc(100% + 14px);
                height: calc(100% + 14px);
                border-radius: 50%;
                background-color: rgba(255, 255, 255, 0.4);
            }
            @include media-1080 {
                width: 60px;
                height: 60px;
            }
            @include media-600 {
                width: 40px;
                height: 40px;
                &:before {
                    left: -4px;
                    top: -4px;
                    width: calc(100% + 8px);
                    height: calc(100% + 8px);
                }
            }
        }
        .video-loading {
            display: none;
            width: 80px;
            height: 80px;
            background: url(//static.chimeroi.com/site/images/home/loading.gif)
                no-repeat;
            background-size: cover;
            @include media-1080 {
                width: 60px;
                height: 60px;
            }
            @include media-600 {
                width: 40px;
                height: 40px;
            }
        }
    }
    .banner-video.autoplay + .media-content,
    .banner-video.is-play + .media-content {
        .video-loading {
            display: none;
        }
        .play-video {
            display: none;
        }
    }
    .banner-video.loading + .media-content {
        .video-loading {
            display: block;
        }
        .play-video {
            display: none;
        }
    }
    .banner-video.is-play ~ .banner-mask {
        display: none;
    }
    .column .media-content-box {
        width: 100%;
    }
    @include media-1080 {
        .row2column .media-content-box {
            width: 100%;
        }
    }
    @include media-min-1080 {
        .row .media-content-box {
            width: auto;
        }
    }
    .banner.multi
        > .pictures-list.swiper-horizontal
        > .swiper-pagination.swiper-pagination-clickable.swiper-pagination-bullets {
        bottom: 30px;
        .swiper-pagination-bullet {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            margin-left: 6px;
            margin-right: 6px;
            background-color: white;
            opacity: 0.5;
            &.swiper-pagination-bullet-active {
                opacity: 1;
            }
        }
    }
    .banner-video {
        .play-video,
        .video-loading {
            display: none;
        }
    }
}
</style>
